import { CardBody, Form, FormGroup, Input, Label, TabContent, TabPane } from "reactstrap";
import { borderData } from "../../../Data/UiKitsData/TabsData";
import { TabDatatype } from "../../../Types/UiKitsType";

import UserProfiles from "../../Apps/Users/UserProfiles";
import AttendanceMe from "../Attendance/AttendanceMe";
import MTPApprovals from "./MTPApprovals";
import LeaveApprovals from "./LeaveApprovals";
import ExpenseApprovals from "./ExpenseApprovals";

export default function ApprovalTabContent({ tabId ,}: { tabId: string,}) {

    const borderData: TabDatatype[] = [
        {
            id: '1',
            text:<MTPApprovals/>
                
        },
    
        {
            id: '2',
            text:
                <LeaveApprovals />

        },
        {
            id: '3',
            text: <ExpenseApprovals />
        }
    ]
    return (
        <TabContent activeTab={tabId}>
            {borderData && borderData.map((item, index) => (
                <TabPane className={`fade ${tabId === item.id ? 'show' : ''}`} tabId={item.id} key={index}>
                    {item.text}
                </TabPane>
            ))}
        </TabContent>
    )
}
